var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.3506H16V18.3506H8V16.3506ZM8 12.3506H16V14.3506H8V12.3506ZM14 2.35059H6C4.9 2.35059 4 3.25059 4 4.35059V20.3506C4 21.4506 4.89 22.3506 5.99 22.3506H18C19.1 22.3506 20 21.4506 20 20.3506V8.35059L14 2.35059ZM18 20.3506H6V4.35059H13V9.35059H18V20.3506Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentGreen);
export default __webpack_public_path__ + "static/media/document-green.20dffb39ff611f5e5f285e113ca050a3.svg";
export { ForwardRef as ReactComponent };